import { useEffect, useState } from 'react';

// Delays propagating a fast-changing value (a search box) so each keystroke
// doesn't fire its own API request.
export default function useDebouncedValue(value, delay = 350) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
